const inputsValidadeStep1 = document.querySelectorAll('.form-step1 .required')
const inputsValidadeStep2 = document.querySelectorAll('.form-step2 .required')
const inputsValidadeStep3 = document.querySelectorAll('.form-step3 .required')
const RequiredFieldValidator = document.querySelectorAll('[data-js="RequiredFieldValidator"]')
const botaoPessoaFisica = document.querySelector('[data-js="p-fisica"]')
const botaoPessoaJuridica = document.querySelector('[data-js="p-juridica"]')
const botaoContinuar = document.querySelector('[data-js="botaoContinuar"]')
const botaoVoltar = document.querySelector('[data-js="botaoVoltar"]')
const selecao = document.querySelector('[data-js="selecao"]')
const forms = document.querySelector('[data-js="forms"]')
const progressBar = document.querySelector('.progressbar')
const step1 = document.querySelector('[data-js="step1"]')
const step2 = document.querySelector('[data-js="step2"]')
const step3 = document.querySelector('[data-js="step3"]')
const botaoScrollCadastro = document.querySelector('[data-js="botao-scroll-cadastro"]')
const comecarCadastro = document.querySelector('.comecarCadastro')
const pnlSalvarInfo = document.getElementById('pnlSalvarInfo')
const btnVoltar2 = document.getElementById('btnVoltar')
const btnContinuar2 = document.getElementById('btnContinuar')
const btnSalvar = document.getElementById('btnSalvar')
const LabelTitleForm = document.getElementById('LabelTitleForm')
//const modalValidadeMessages = new bootstrap.Modal(document.getElementById("validadeMessages"), {});

let step = 0;

const hideWrapperComecar = () => selecao.classList.add('d-none')
const showpnlSalvarInfo = () => pnlSalvarInfo.classList.remove('d-none')



function showNextStep() {
    if (step === 1) {
        forms.classList.remove('d-none')
        step1.classList.add('active')
        //step = step + 1
        return false

    }

    if (step === 2) {
        //step = step + 1
        progressBar.querySelector('[data-js="1"]').classList.add('completed')
        progressBar.querySelector('[data-js="2"]').classList.add('active')
        step1.classList.add('d-none')
        step2.classList.remove('d-none')
        return false
    }

    if (step === 3) {
        if (!validaStep(inputsValidadeStep2)) {
            step = step - 1;
            return false;
        }

        if ($("#rdJuridica").is(":checked") && !$("#chkIsentoCCM").is(":checked") && $("#txtCCM").val().trim() === "") {
            alert("O campo Inscri\u00E7\u00E3o Municipal \u00E9 obrigat\u00F3rio para o cadastro de Pessoa Jur\u00EDdica.");
            step = step - 1;
            return false;
        }

        progressBar.querySelector('[data-js="2"]').classList.add('completed')
        progressBar.querySelector('[data-js="3"]').classList.add('completed')
        step2.classList.add('d-none')
        step3.classList.remove('d-none')
        botaoContinuar.classList.add('d-none')
        botaoVoltar.classList.add('d-none')
        showpnlSalvarInfo()
        btnContinuar2.classList.add('d-none')
        return false
    }
}

function handleBotaoContinuar() {
    if (step === 1) {
        validaDocumento(true);
    } else {
        showNextStepAdd();
    }
}


function showNextStepAdd() {
    step = step + 1;
    return showNextStep();
}


function stepBack() {
    if (step === 3) {
        console.log(step);
        step = step - 1
        progressBar.querySelector('[data-js="2"]').classList.remove('completed')
        progressBar.querySelector('[data-js="3"]').classList.remove('completed')
        step3.classList.add('d-none')
        step2.classList.remove('d-none')
        botaoContinuar.classList.remove('d-none')
        botaoVoltar.classList.remove('d-none')
        return false
    }

    if (step === 2) {
        console.log(step);
        step = step - 1
        progressBar.querySelector('[data-js="1"]').classList.remove('completed')
        step2.classList.add('d-none')
        step1.classList.remove('d-none')
        return false
    }

    if (step === 1) {
        console.log(step);
        step = step - 1
        forms.classList.add('d-none')
        selecao.classList.remove('d-none')
        return false
    }
}

function handleShowFormPessoaFisica() {
    step = step + 1
    hideWrapperComecar()
    showNextStep()
}

function handleShowFormPessoaJuridica() {
    step = step + 1
    hideWrapperComecar()
    showNextStep()
}

function ValidaEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(email)) {
        return false;
    }
    else {
        return true;
    }
}

function ValidaSenha(senha) {
    var regex = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
    if (!regex.test(senha)) {
        return false;
    }
    else {
        return true;
    }
}

function validaStep(inputsValidadeStep) {
    var i;
    var y;
    var strSenha;
    var strConfirmarSenha;
    var strCelular;
    var strTelefone;
    var strDDDTel;
    var strDDDCel;
    var strEmail;
    var strConfirmarEmail;
    var ddlProfissoes;

    for (i = 0; i < inputsValidadeStep.length; i++) {

        if (inputsValidadeStep[i].name == "txtEmail") strEmail = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "txtConfirmarEmail") strConfirmarEmail = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "txtSenha") strSenha = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "txtConfirmarSenha") strConfirmarSenha = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "txtTelefone") strTelefone = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "txtDDDTel") strDDDTel = inputsValidadeStep[i].value;
        if (inputsValidadeStep[i].name == "ddlProfissoes") ddlProfissoes = inputsValidadeStep[i].value;
        //Os campos de celular n�o s�o obrigat�rios, portanto n�o s�o retornados no inputsValidadeStep
        //if (inputsValidadeStep[i].name = "txtDDDCel") strDDDCel = inputsValidadeStep[i].value; 
        //if (inputsValidadeStep[i].name = "txtCelular") strCelular = inputsValidadeStep[i].value;


        if (inputsValidadeStep[i].value == "") {
            for (y = 0; y < RequiredFieldValidator.length; y++) {
                if (RequiredFieldValidator[y].attributes['controltovalidate'].value == inputsValidadeStep[i].name) {
                    alert(RequiredFieldValidator[y].attributes['errormessage'].value);
                    if (inputsValidadeStep[i].name != "txtCEP") {
                        inputsValidadeStep[i].focus();
                    }
                    return false;
                }
            }
        }
    }

    if ((typeof (strEmail) !== "undefined" && strEmail !== null) && !ValidaEmail(strEmail)) {
        alert("No campo E-mail preencha um e-mail v\u00e1lido.");
        return false;
    }

    if (strEmail != strConfirmarEmail) {
        alert("Os campos E-mail e Confirmar E-mail devem ser iguais.");
        return false;
    }

    if (strSenha.length < 8) {
        alert("O campo Senha deve ter no m\u00ednimo 8 caracteres.");
        return false;
    }

    if ((typeof (strSenha) !== "undefined" && strSenha !== null) && !ValidaSenha(strSenha)) {
        alert("O campo Senha deve conter no m\u00ednimo uma letra mai\u00fascula, no m\u00ednimo um n\u00famero, no m\u00ednimo um caracter especial e ter m\u00ednimo 8 caracteres.");
        return false;
    }

    if (strSenha != strConfirmarSenha) {
        alert("Os campos Senha e Confirmar Senha devem ser iguais.");
        return false;
    }

    if (strDDDTel.length != 2) {
        alert("O Campo DDD do Celular deve conter 2 caracteres numericos.");
        return false;
    }

    if (strTelefone.length < 7) {
        alert("O Campo Celular deve conter no m\u00ednimo 7 caracteres.");
        return false;
    }

    if (ddlProfissoes === '0') {
        alert("Campo Profiss\u00E3o obrigat\u00F3rio.");
        return false;
    }

    //Os campos de celular n�o s�o obrigat�rios, portanto n�o s�o retornados no inputsValidadeStep
    //if (strDDDCel.length != 2) {
    //    alert("O Campo DDD do Celular deve conter 2 caracteres num�ricos.");
    //    return false;
    //}

    //if (strCelular.length < 7) {
    //    alert("O Campo Celular deve conter no m�nimo 7 caracteres.");
    //    return false;
    //}   

    return true;
}


function showEditStep() {

    document.getElementById('captcha2').style.display = "none";
    hideWrapperComecar();
    comecarCadastro.classList.remove('d-none');
    progressBar.classList.add('d-none');
    LabelTitleForm.innerText = "Confirme seus dados";
    step1.classList.add('d-none');
    step2.classList.remove('d-none');
    step3.classList.remove('d-none');
    botaoContinuar.classList.add('d-none');
    botaoVoltar.classList.add('d-none');
    btnVoltar2.classList.add('d-none');
    btnContinuar2.classList.add('d-none');
    forms.classList.remove('d-none');
}

btnSalvar.addEventListener('click', function (e) {
    if (!validaStep(inputsValidadeStep3)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    return true;
});


botaoPessoaFisica.addEventListener('click', handleShowFormPessoaFisica)
botaoPessoaJuridica.addEventListener('click', handleShowFormPessoaJuridica)
botaoContinuar.addEventListener('click', handleBotaoContinuar)
btnContinuar2.addEventListener('click', showNextStep)
botaoVoltar.addEventListener('click', stepBack)
btnVoltar2.addEventListener('click', stepBack)
if (botaoScrollCadastro) {
    botaoScrollCadastro.addEventListener('click', () =>
        comecarCadastro.scrollIntoView({ block: 'start', behavior: 'smooth' })
    )
}

